import "./index.scss";

import classNames from "classnames";

import Loading from "@src/ui/Loading";
import { CDN_UPLOAD_URL } from "@config";
import { Trans } from "react-i18next";

export default ({ className, loadingText, bgImg }: { className?: string; loadingText?: string; bgImg?: string }) => {
  return (
    <div
      className={classNames(
        "flex flex-col items-center justify-center gap-[8px]",
        {
          "bg-cover bg-center bg-no-repeat": !!bgImg,
        },
        className,
      )}
      style={{
        backgroundImage: bgImg ? `url(${CDN_UPLOAD_URL}/upload/${bgImg})` : "none",
      }}
    >
      <Loading></Loading>
      <div className="loading-text">
        <Trans>{loadingText || "Loading"}</Trans>
      </div>
    </div>
  );
};
